module.exports = __webpack_public_path__ + "img/AdobeStock_WomanDriver.249ce9ac.jpeg";